<template>
  <div class="incenters">
    <div style="">
      <Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser" :src="require('@/assets/icon/icon-add.png')">
      </Commonbtn>
      <Commonbtn backgroundColor="#FFF" v-if="qx.update" title="修改" fontSize="14px" @btnclick="update" :src="require('@/assets/icon/icon-update.png')">
      </Commonbtn>
      <Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del" :src="require('@/assets/icon/icon-del.png')">
      </Commonbtn>
      <!-- <CommonbtnUpLoad v-if="qx.add" style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF" title="导入" fontSize="14px" @getFile="proImport" types="file" :src="require('@/assets/icon/icon-drjys.png')">
      </CommonbtnUpLoad>
      <a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;" @click="ProductlineDowload">下载产品线档案导入模版</a> -->
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div class="TableWidth">
      <Commontable @onRowClick="onRowClick" colnum=81 :tableData="tableData" :headerData="headerData" height="100%">
      </Commontable>
      <div class="pagination">
        <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total"></Pagination>
      </div>
    </div>
    <DialogFrom width="1000px" title="新增产品线档案" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
      <div class="from">
        <template v-for="(item , index) of fromdataadd">
          <Commondropdownlist ref="productAdd" :key="index" :options="item.options" :btx="item.btx" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata" :disabled="item.disabled">
          </Commondropdownlist>
        </template>
      </div>
    </DialogFrom>
    <DialogFrom width="1000px" title="修改产品线档案" :dialogVisible="dialogVisiblesedit" @cancel="canceledit" @dialogOK="dialogOKedit">
      <div class="from">
        <template v-for="(item , index) of fromdataedit">
          <Commondropdownlist ref="productupdate" :key="index" :options="item.options" :btx="item.btx" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata" :disabled="item.disabled">
          </Commondropdownlist>
        </template>
      </div>
    </DialogFrom>
    <DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg" @dialogOK="dialogOKdrjg">
      <div class="from">
        <Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
        </Commontable>
      </div>
    </DialogFrom>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条档案吗？</span>
    </Dialog>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate" @dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用这条档案吗？</span>
    </Dialog>
  </div>
</template>
<script>
import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
import Commontable from '../../../../components/common-table.vue'
import Commonbtn from '../../../../components/common-btn.vue'
import Pagination from '../../../../components/pagination.vue'
import DialogFrom from '../../../../components/dialog-from.vue'
import fromdata from '../fromData/add'
import fromdataedit from '../fromData/edit'
import Dialog from '../../../../components/dialog.vue'
import Commondown from '../../../../components/common-down.vue'
import CommonbtnUpLoad from '../../../../components/common-upload.vue'
import {
  InventoryClassAdd,
  InventoryClassInfo,
  InventoryClassEdit,
  InventoryClassDelete,
  InventoryImport,
  InventoryDownloadTemplet,
 BaOrganizationList 
} from '@/api/home'
export default {
  components: {
    Commontable,
    Commonbtn,
    Pagination,
    DialogFrom,
    Commondropdownlist,
    Dialog,
    Commondown,
    CommonbtnUpLoad
  },
  props: {
    tableData: {
      type: Array,
      default: []
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      dialogVisibles: false,
      dialogVisiblesedit: false,
      dialogVisibledel: false,
      dialogVisibledeactivate: false,
      dialogVisiblesU8: false,
      dialogVisiblesU8d: false,
      rightboo: false,
      dwonleft: false,
      rowboo: false,
      dialogVisiblesdrjg: false,
      title: '',
      invClass: '',
      invClassName: '',
      isBarCodeControl: '',
      parentClass: '',
      invClassupdate: '',
      invClassNameupdate: '',
      ptype: '',
      fromdataadd: [],
      fromdataedit: [],
      tableDatadrjg: [],
      fromdataU8: [
        {
          inputdata: '',
          title: 'U8账套',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '210px',
          lablewith: '55px'
        }, {
          inputdata: '',
          title: 'U8编号',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '210px',
        },
      ],
      headerData: [
        {
          prop: 'id',
          label: '序号',
          columnwidth: 50
        },
        {
          prop: 'InvClass',
          label: '产品线编号',
          columnwidth: 80
        },
        {
          prop: 'InvClassName',
          label: '产品线名称',
          columnwidth: 130
        },
         {
          prop: 'Abbr',
          label: '简称',
          columnwidth: 130
        },
        {
          prop: 'IsBarCodeControl',
          label: '是否唯一码管理',
          columnwidth: 130
        },
        {
          prop: 'ParentClassName',
          label: '上级产品线名称',
          columnwidth: 130
        },
        {
          prop: 'ParentClass',
          label: '上级产品线编号',
          columnwidth: 60
        },
        {
          prop: 'Grade',
          label: '层级',
          columnwidth: 60
        },
        
        {
          prop: 'Creator',
          label: '创建人',
          columnwidth: 90
        },
         {
          prop: 'CreateTime',
          label: '创建人时间',
          columnwidth: 150
        },
          {
          prop: 'Updater',
          label: '修改人',
          columnwidth: 100
        },
         {
          prop: 'UpdateTime',
          label: '修改人时间',
          columnwidth: 250
        },
      ],
      downlist: [
        { title: 'U8配置' },
        { title: '导入U8配置' },
      ],
      qus: [],
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
        enabled: false,
        submit: false,
        skip: false,//跳过
        reset: false, //重置
        setting: false
      },
    }
  },
  mounted() {
    this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
    this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
    this.QX()
  },
  methods: {
    QX() {
      let data = JSON.parse(localStorage.getItem("MenusData"))
      let MenuID = this.$route.query.MenuID
      // console.log(data.Menus[0].Nodes[1], "data")
       data.Menus[0].Nodes.map((item, index) => {
        if (item.NodeID == 34) {
          item.Nodes.map((items, indexs) => {
            if (items.NodeID == 39) {
              this.qus = items.Nodes
            }
          })
        }
      // console.log(this.qus, 'this.qus');
      })
      if (this.qus) {
        this.qus.map((item, index) => {
          if (item.NodeName == 'add') {
            this.qx.add = true
          } else if (item.NodeName == 'edit') {
            this.qx.update = true
          } else if (item.NodeName == 'delete') {
            this.qx.del = true
          } else if (item.NodeName == 'stopif') {
            this.qx.del = true
          } else if (item.NodeName == 'assignment') {
            this.qx.assignment = true
          } else if (item.NodeName == 'enabled') {
            this.qx.enabled = true
          } else if (item.NodeName == 'skip') {
            this.qx.skip = true
          } else if (item.NodeName == 'reset') {
            this.qx.reset = true
          } else if (item.NodeName == 'setting') {
            this.qx.setting = true
          }
        })
      }
    },
    // 导入
    async inventoryImport(file) {
      if (file) {
        const loading = this.$loading({
          lock: true,
          text: '上传中...',
          spinner: 'el-icon-loading',
          background: 'rgba(255,255,255,0.3)'
        });
        let formData = new FormData()
        formData.append("file", file)
        let res = await InventoryImport(formData)
        if (res.code == 0) {
          this.dialogVisiblesdrjg = true
          this.tableDatadrjg = res.data
          this.title = "导入结果"
          this.$message({
            type: 'success',
            message: res.message
          })
          loading.close();
        } else if (res.code == 101) {
          this.$message({
            type: 'warning',
            message: res.message
          })
          loading.close();
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
          loading.close();
        }
        loading.close();
      }
    },
    // 导出模板
    async inventoryDownloadTemplet() {
      let {
        data,
        code,
        message
      } = await InventoryDownloadTemplet({})
      if (code == 0) {
        window.location.href = data
      } else if (code == 101) {
        this.$message({
          type: 'warning',
          message: message
        });
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }
    },
    proImport(file) {
      this.inventoryImport(file)
    },
    ProductlineDowload() {
      this.inventoryDownloadTemplet()
    },
    // 新增
    async InventoryClassAdd() {
      let {
        code,
        message
      } = await InventoryClassAdd({
        invClass: this.invClass,
        invClassName: this.invClassName,
        parentClass: this.parentClass,
        isBarCodeControl: this.isBarCodeControl ? 1 : 0
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '新增成功'
        });
        this.$parent.inventoryClassList()
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }
       this.$refs.productAdd.map((item,index)=>{
          item.modelvalue = ""
        })
    },
    // 详情
    async inventoryClassInfo() {
      let {
        code,
        data
      } = await InventoryClassInfo({
        invClass: this.invClassupdate,
        invClassName: this.invClassNameupdate,
      })
      if (code == 0) {
        this.$refs.productupdate[0].modelvalue = data.InvClass
        this.$refs.productupdate[1].modelvalue = data.InvClassName
        this.$refs.productupdate[2].modelvalue = data.IsBarCodeControl + ""
        this.$refs.productupdate[3].modelvalue = data.ParentClass
      }
    },
    // 修改
    async inventoryClassEdit(datalist) {
      let {
        code,
        message
      } = await InventoryClassEdit({
        invClass: datalist[0].modelvalue,
        invClassName: datalist[1].modelvalue,
        parentClass: datalist[3].modelvalue,
        isBarCodeControl: Number(datalist[2].modelvalue)
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '修改成功'
        });
        this.$parent.inventoryClassList()
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }
    },
    // 删除
    async inventoryClassDelete() {
      let {
        code,
        message
      } = await InventoryClassDelete({
        invClass: this.invClassupdate,
        invClassName: this.invClassNameupdate,
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '删除成功'
        });
        this.$parent.inventoryClassList()
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }
    },
    onRowClick(val) {
      this.rowboo = true
      //console.log(val, "val")
      this.invClassupdate = val.InvClass
      this.invClassNameupdate = val.InvClassName
    },
    commclick(type) {
      this[type] = true
    },

    handleCurrentChange(pageindex) {
      this.$emit('handleCurrentChange', pageindex)
    },
    handleSizeChange(paegSzie) {
      this.$emit('handleSizeChange', paegSzie)
    },
    adduser() {
      this.baOrganizationList()
      this.dialogVisibles = true
      //console.log(this.fromdataadd, '//console.log(this.fromdataadd)')
    },
    cancel() {
      this.dialogVisibles = false
    },
    dialogOK() {
      // //console.log(this.$refs.productAdd)
      // debugger;
      this.invClass = this.$refs.productAdd[0].modelvalue
      this.invClassName = this.$refs.productAdd[1].modelvalue
      this.isBarCodeControl = this.$refs.productAdd[2].modelvalue
      this.parentClass = this.$refs.productAdd[3].modelvalue
      this.InventoryClassAdd()
      this.dialogVisibles = false
    },
    async baOrganizationList(){
      let {
        data,
        code
      } = await BaOrganizationList({})
    },
    update() {
      if (this.rowboo == true) {
        this.dialogVisiblesedit = true
        this.inventoryClassInfo()
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要修改的数据！'
      });

    },
    canceledit() {
      this.dialogVisiblesedit = false
    },
    dialogOKedit() {
      //console.log(this.$refs.productupdate, 'update')
      // return false
      this.inventoryClassEdit(this.$refs.productupdate)
      this.dialogVisiblesedit = false
    },
    del() {
      if (this.rowboo == true) {
        this.dialogVisibledel = true
        this.inventoryClassInfo()
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要修改的数据！'
      });
    },
    canceldel() {
      this.dialogVisibledel = false
    },
    dialogOKdel() {
      this.inventoryClassDelete()
      this.dialogVisibledel = false
    },
    deactivate() {
      this.dialogVisibledeactivate = true
    },
    canceldeactivate() {
      this.dialogVisibledeactivate = false
    },
    dialogOKdeactivate() {
      this.dialogVisibledeactivate = false
    },
    downs(index) {
      //console.log("index", index)
      if (index == 0) {
        this.dialogVisiblesU8 = true
      }
      if (index == 1) {
        this.dialogVisiblesU8d = true
      }
    },
    cancelU8() {
      this.dialogVisiblesU8 = false
    },
    dialogOKeditU8() {
      this.dialogVisiblesU8 = false
    },
    cancelU8d() {
      this.dialogVisiblesU8d = false
    },
    dialogOKeditU8d() {
      this.dialogVisiblesU8d = false
    },
    canceldrjg() {
      this.dialogVisiblesdrjg = false
    },
    dialogOKdrjg() {
      this.dialogVisiblesdrjg = false
    },

  }
}
</script>

<style lang="less" scoped>
.incenters {
  height: 100%;

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    padding-bottom: 16px;
  }

  // div {
  //   margin-left: 8px;
  //   margin-right: 8px;
  //   margin-top: 5px;
  //   margin-bottom: 5px;

  // }
  .from {
    width: 100%;
  }

  .signingroles {
    height: 500px;
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // border: 1px solid red;

    .left {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
    }

    .right {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
      // pointer-events: none;
    }
  }
}

.right-s {
  position: absolute;
  z-index: 99;
  opacity: 0.5;
  right: 21px;
  width: 470px;
  height: 240px;
  background-color: #ffffff;
  cursor: no-drop;
}

.dwonleft {
  width: 170px;
  height: 48px;
  position: absolute;
  background-color: #ffffff;
  z-index: 99;
  right: 350px;
  top: 322px;
  text-align: center;
  line-height: 48px;
  color: #333333;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
}

.dwonleft:hover {
  background-color: #f0f0f0;
}
</style>
